export interface HttpRequest<T = any> {
  method: RequestType;
  url: string;
  responseType?: ResponseType;
  headers?: any;
  params?: any;
  data?: T;
}

export enum RequestType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum ResponseType {
  BLOB = 'blob',
  JSON = 'json',
}
